module.exports = __webpack_public_path__ + "static/img/release_foot.f6cc6ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/release_foot.png
// module id = D4CL
// module chunks = 0